// Username validation + normalization shared by the login and reset-password
// forms so the two can't drift apart. A username is either an email or a US
// phone number.
//
// Phones are stored E.164 (`+15551234567`) and abobo-api matches them by exact
// string (rodauth_patient `account_from_login` only prepends `+1`, it does not
// strip formatting). So the portal is responsible for reducing whatever the
// patient types to the bare 10 digits the lookup expects. Emails pass through
// untouched — the API does the authoritative email match.

const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;

const isEmail = (value: string): boolean => EMAIL_PATTERN.test(value);

// Reduce a phone entry to its 10 significant digits, tolerating any separators
// (spaces, dashes, parens, dots) and a leading US country code (1 / +1).
const toPhoneDigits = (value: string): string => {
  const digits = value.replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1')
    ? digits.slice(1)
    : digits;
};

// True when the value is an email or a phone that reduces to 10 digits.
export const isValidUsername = (value: string): boolean => {
  const trimmed = value.trim();
  return isEmail(trimmed) || toPhoneDigits(trimmed).length === 10;
};

// Clean a username for the API: emails as-is, phones as bare 10 digits.
export const normalizeUsername = (value: string): string => {
  const trimmed = value.trim();
  return isEmail(trimmed) ? trimmed : toPhoneDigits(trimmed);
};
